var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.stockInfo.name || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.stockInfo.modelSpec || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.stockInfo.catName || ""))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.stockInfo.brandName || ""))])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.stockList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "warehouseName", label: "仓库名称" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "quantity",
                label: "数量",
                width: "160",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.quantity != null
                        ? _c("span", [_vm._v(_vm._s(rows.row.quantity))])
                        : _c("span", [_vm._v("0")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "normalQuantity",
                label: "良品数量",
                width: "100",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "defectQuantity",
                label: "不良品数量",
                width: "100",
                align: "right"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "unit",
                label: "单位",
                width: "100",
                align: "center"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "单价（元）", width: "120", align: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.price != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.price.toFixed(2)))
                          ])
                        : _c("span", [_vm._v("0.00")])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("库存信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3764c022", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3764c022","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shareAcc/AccStockListForAccDef.vue
// module id = 2833
// module chunks = 0